import * as React from "react";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useSelector, useDispatch } from "react-redux";
import { commonActions } from "stores/common/commonActions.js";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function SnackBarContainer() {
    const snackbar = useSelector((state) => state.common.snackbar);
    const dispatch = useDispatch();

    const handleClose = (e, reason) => {
        if (reason === "clickaway") {
            return;
        }
      
        dispatch(
            commonActions.setSnackbarAction({
                open: false,
                message: snackbar.message,
                severity: snackbar.severity,

            })
        )
    };

    return (
        <Stack spacing={2} sx={{ width: "100%" }}>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleClose}
            >
                <Alert
                    onClose={handleClose}
                    severity={snackbar.severity}
                    sx={{ width: "100%" }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Stack>
    );
}
